<template>
  <div class="racNoticeList">
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_wj_addNews')}}</el-button>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="proprietorNotificationListbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- <el-table-column prop="title" :label="$t('lang.lbl_wj_newsTitle')">
        </el-table-column> -->
        <el-table-column prop="title" :label="$t('lang.lbl_wj_newsTitle')" width=400>
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.title&&scope.row.title.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.title }}
                </span>
              </div>
              <div>
                {{ scope.row.title.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span v-if="scope.row.title.length>require('@/config/enum').tableDatamaxlength">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.title | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="sendTypeName" label="通知平台">
        </el-table-column>
        <!-- <el-table-column prop="url" label="通知链接">
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank">{{scope.row.url}}</a>
          </template>
        </el-table-column> -->
        <el-table-column prop="url" label="通知链接" width=400>
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.url&&scope.row.url.length> require('@/config/enum').tableDatamaxlength40"
              :disabled="false">
              <div slot="content">
                  <a :href="scope.row.url" target="_blank">{{scope.row.url}}</a>
              </div>
              <div>
                <a :href="scope.row.url" target="_blank">{{ scope.row.url.substring(0, require('@/config/enum').tableDatamaxlength40) | valueIsNull }}</a>
                <span v-if="scope.row.url.length>require('@/config/enum').tableDatamaxlength40">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="开始时间" sortable>
          <template slot-scope="scope">
            {{ scope.row.startTime | time }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="结束时间" sortable>
          <template slot-scope="scope">
            {{ scope.row.endTime | time }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 新增跑马灯通知弹窗 -->
    <el-dialog :title="noticeTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" center top="130px"
      width="900px">
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws10" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="通知标题" prop="title">
          <el-input type="textarea" :rows="3" v-model="ruleForm.title" placeholder="请输入通知标题" class="item-input" style="width:90%" maxlength="100">
          </el-input>
        </el-form-item>
        <el-form-item tem label="通知平台" prop="sendType">
          <el-checkbox-group v-model="ruleForm.sendType" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="(item,index) in sendTypelist" :key="index" :label="item.id" :value="item.id">
              {{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item tem label="通知有效期" prop="noticeTime">
          <el-date-picker v-model="ruleForm.noticeTime" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="timestamp" style="width:90%">
          </el-date-picker>
        </el-form-item>
        <el-form-item tem label="通知链接" prop="url">
          <el-input v-model="ruleForm.url" placeholder="请输入通知链接" class="item-input" style="width:90%">
          </el-input>
        </el-form-item>
        <div class="jump-btn" style="text-align:center">
          <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
            保存
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:racNoticeList
   *@Description:跑马灯通知
   *@author:宋莎
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.racNoticeList',
    data() {
      return {
        multipleSelection: [], // 多选框
        gardenId: this.$store.getters.gardenId, // 小区绑定值
        tableData: [], // 通知list
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        dialogVisible: false, // 新增弹窗状态
        saveData: '',
        noticeTitle: '新增通知', // 新增弹窗标题
        sendTypelist: [{
            name: 'APP业主端',
            id: '1'
          },
          {
            name: 'APP物业端',
            id: '2'
          },
          {
            name: '后台系统',
            id: '3'
          },
        ], // 通知平台
        rules: {
          title: [{
            required: true,
            message: '请输入通知标题',
            trigger: 'blur'
          }],
          sendType: [{
            required: true,
            message: '请选择通知平台',
            trigger: 'change'
          }],
          noticeTime: [{
            required: true,
            message: '请选择通知有效期限',
            trigger: 'change'
          }],
        },
        ruleForm: {
          id: '',
          title: '', // 通知标题
          sendType: [], // 通知平台
          url: '', // 通知链接
          noticeTime: [], // 通知有效期
        },
        isDisabled: false,
        proprietorNotificationListbox: require('@/config/enum').proprietorNotificationListbox // 是否隐藏复选框
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
      dialogVisible: {
        handler(newVal, oldVal) {
          if (newVal == false) {
            this.ruleForm.id = ''
            this.ruleForm.title = ''
            this.ruleForm.sendType = []
            this.ruleForm.url = ''
            this.ruleForm.noticeTime = []
          }
        },
        deep: true,
        immediate: true
      },
    },
    created() {
      this.getData()
    },
    activated() {
      this.getData()
    },
    methods: {
      // 获取列表数据
      getData() {
        let loading = this.$loading()
        this.$get(`/racNotice?gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      handleCheckedCitiesChange(value) {
        console.log(value)
      },
      // 新增
      add() {
        this.dialogVisible = true
        this.isDisabled = false
        this.isFlag = false
      },
      // 编辑
      edit(rowData) {
        this.dialogVisible = true
        this.isDisabled = true
        this.isFlag = true
        let sendType = (rowData.sendType.split(',')).sort()
        let noticeTime = []
        noticeTime.push(rowData.startTime)
        noticeTime.push(rowData.endTime)
        this.ruleForm.id = rowData.id
        this.ruleForm.title = rowData.title
        this.ruleForm.sendType = sendType
        this.ruleForm.url = rowData.url
        this.ruleForm.noticeTime = noticeTime
        this.saveData = JSON.stringify(this.ruleForm)
      },
      // 保存
      save(formName) {
        let params = {}
        if (this.isFlag) {
          params.id = this.ruleForm.id
        }
        params.gardenId = this.gardenId
        params.title = this.ruleForm.title
        params.sendType = this.ruleForm.sendType.join(',')
        params.url = this.ruleForm.url
        params.startTime = this.ruleForm.noticeTime[0]
        params.endTime = this.ruleForm.noticeTime[1]
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            // 新增
            if (!params.id) {
              this.$post('/racNotice', params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.reset()
                    this.commit()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                  this.reset()
                }
              )
            } else {
              // 编辑
              this.$patch(`/racNotice/${this.ruleForm.id}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.reset()
                    this.commit()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                  this.reset()
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 删除新闻
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/racNotice/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 更新
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 重置
      reset() {
        this.dialogVisible = false
        this.ruleForm.id = ''
        this.ruleForm.title = ''
        this.ruleForm.sendType = []
        this.ruleForm.url = ''
        this.ruleForm.noticeTime = []
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    }
  }
</script>

<style lang="scss">
  .el-tooltip__popper.is-light {
    max-width: 300px;
  }
</style>